export default class User {
  constructor(public userName: string,
              public firstName: string,
              public middleName: string,
              public lastName: string,
              public email: string,
              public phoneNumber: string) {
  }

  static  createFromRequest(request: any): User {
    const { userName, firstName, middleName, lastName, email, phoneNumber } = request;
    return new User(userName, firstName, middleName, lastName, email, phoneNumber);
  }
}



// WEBPACK FOOTER //
// ./src/models/user.ts